import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import PageTitle from '../../../components/PageTitle/PageTitle';
import CardGrid from '../../../components/Layout2/CardGrid/CardGrid';
import { ASSETS_BASE_URL } from '../../../config';
import { useTranslation } from 'react-i18next';


const Service = () => {
    const { t } = useTranslation();

    const serviceData = useMemo(() => ([
        { title: t('LABELS.DIGITAL_SOLUTIONS'), img: `${ASSETS_BASE_URL}/ImageBoxes/digital_solutions.jpg`, href: '/service/digital-solutions' },
        { title: t('LABELS.CASES_TICKETS'), img: `${ASSETS_BASE_URL}/ImageBoxes/cases.jpg`, href: '/service/cases' },
        { title: t('LABELS.WORK_ORDERS_REPORTS'), img: `${ASSETS_BASE_URL}/ImageBoxes/work_orders.jpg`, href: '/service/workorders' },
    ]), [t]);

    return (
        <Box sx={{ p: 2, pt: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <PageTitle title={t('LABELS.SERVICE')} />
            <CardGrid data={serviceData} />
        </Box>
    );
};

export default Service;
